module.exports = __webpack_public_path__ + "img/2.7f2121e8.jpg";